import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

const initializeCarousel = ( root ) => {
	if ( root.dataset.emblaInitialized === 'true' ) {
		return;
	}

	const viewport = root.querySelector( ':scope > .webpages-embla__viewport' );
	if ( ! viewport ) {
		return;
	}

	root.dataset.emblaInitialized = 'true';

	const plugins = [];

	const prefersReducedMotion = root.ownerDocument.defaultView.matchMedia(
		'(prefers-reduced-motion: reduce)'
	).matches;

	if ( root.dataset.autoplay === 'true' && ! prefersReducedMotion ) {
		plugins.push(
			Autoplay( {
				delay: Math.max(
					Number( root.dataset.autoplayDelay ) || 5000,
					1000
				),
				stopOnInteraction: false,
				stopOnMouseEnter: true,
			} )
		);
	}

	const embla = EmblaCarousel(
		viewport,
		{
			align: 'start',
			containScroll: 'trimSnaps',
			direction:
				root.ownerDocument.documentElement.dir === 'rtl'
					? 'rtl'
					: 'ltr',
		},
		plugins
	);
	const previousButton = root.querySelector(
		':scope > .webpages-embla__arrows .webpages-embla__arrow--previous'
	);
	const nextButton = root.querySelector(
		':scope > .webpages-embla__arrows .webpages-embla__arrow--next'
	);
	const dots = root.querySelector( ':scope > .webpages-embla__dots' );

	const updateButtons = () => {
		if ( previousButton ) {
			previousButton.disabled = ! embla.canScrollPrev();
		}
		if ( nextButton ) {
			nextButton.disabled = ! embla.canScrollNext();
		}
	};

	const createDots = () => {
		if ( ! dots ) {
			return;
		}

		dots.replaceChildren();
		embla.scrollSnapList().forEach( ( _, index ) => {
			if ( embla.scrollSnapList().length < 2 ) return;
			const button = root.ownerDocument.createElement( 'button' );
			button.type = 'button';
			button.className = 'webpages-embla__dot';
			button.setAttribute(
				'aria-label',
				`${ root.dataset.dotLabel || 'Zu Slide' } ${ index + 1 }`
			);
			button.addEventListener( 'click', () => embla.scrollTo( index ) );
			dots.append( button );
		} );
	};

	const updateDots = () => {
		if ( ! dots ) {
			return;
		}

		const selectedIndex = embla.selectedScrollSnap();
		Array.from( dots.children ).forEach( ( dot, index ) => {
			dot.classList.toggle( 'is-selected', index === selectedIndex );
			if ( index === selectedIndex ) {
				dot.setAttribute( 'aria-current', 'true' );
			} else {
				dot.removeAttribute( 'aria-current' );
			}
		} );
	};

	previousButton?.addEventListener( 'click', () => embla.scrollPrev() );
	nextButton?.addEventListener( 'click', () => embla.scrollNext() );
	embla.on( 'init', createDots );
	embla.on( 'reInit', createDots );
	embla.on( 'init', updateButtons );
	embla.on( 'reInit', updateButtons );
	embla.on( 'select', updateButtons );
	embla.on( 'init', updateDots );
	embla.on( 'reInit', updateDots );
	embla.on( 'select', updateDots );
	createDots();
	updateButtons();
	updateDots();

	root.addEventListener(
		'webpages-embla-destroy',
		() => {
			embla.destroy();
			delete root.dataset.emblaInitialized;
		},
		{ once: true }
	);
};

document
	.querySelectorAll( '.wp-block-webpages-embla-carousel.webpages-embla' )
	.forEach( initializeCarousel );
